import { FormEvent, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../api';
import { useAuth } from '../auth';
import { useT } from '../i18n';
import Wordmark from '../components/Wordmark';
import Notice from '../components/Notice';

export default function ResetPassword() {
  const { t } = useT();
  const { adoptSession } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    if (next !== confirm) { setError(t('pw.mismatch')); return; }
    setBusy(true); setError(null);
    try {
      const r = await resetPassword(token, next);
      adoptSession(r.token, r.user);
      nav('/', { replace: true });
    } catch (err) { setError((err as Error).message); }
    finally { setBusy(false); }
  }

  return (
    <div className="min-h-dvh flex items-center justify-center p-6">
      <form onSubmit={onSubmit} className="card w-full max-w-sm p-6 space-y-5">
        <Wordmark />
        <div><h1 className="text-xl font-semibold">{t('rs.title')}</h1><p className="text-dim text-sm mt-1">{t('rs.blurb')}</p></div>
        {!token ? <Notice kind="error">{t('rs.notoken')}</Notice> : (
          <>
            <div><label className="label" htmlFor="new">{t('pw.new')}</label>
              <input id="new" type="password" autoComplete="new-password" minLength={8} value={next} onChange={(e) => setNext(e.target.value)} required /></div>
            <div><label className="label" htmlFor="conf">{t('pw.repeat')}</label>
              <input id="conf" type="password" autoComplete="new-password" minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></div>
            {error && <Notice kind="error">{error}</Notice>}
            <button className="btn-primary w-full" disabled={busy}>{busy ? t('rs.busy') : t('rs.submit')}</button>
          </>
        )}
        <Link to="/forgot" className="block text-center text-sm text-dim hover:text-chalk">{t('f.title')}</Link>
      </form>
    </div>
  );
}
